// extracted by mini-css-extract-plugin
module.exports = {"TypeTitle":"Type_TypeTitle__34r98","TypeText":"Type_TypeText__2EfGE"};